export default require("../templates/Projects").default
